<template>
  <Drawer
    width="400"
    v-model="drawerOpened"
    :title="currentSales.abbr"
  >
    <div class="drawer-wrap">
      <div class="drawer-contetn">
        <Form
          ref="formItem"
          :model="formItem"
          label-position="top"
        >
          <div class="formItem-content">
            <FormItem
              label="是否通过审核，允许销售"
              prop="allowSales"
            >
              <RadioGroup v-model="formItem.allowSales">
                <Radio label="true">是</Radio>
                <Radio label="false">否</Radio>
              </RadioGroup>
            </FormItem>
            <FormItem
              label="仅限预付款发货，每单需要审核"
              prop="prePaidOnly"
            >
              <RadioGroup v-model="formItem.prePaidOnly">
                <Radio label="true">是</Radio>
                <Radio label="false">否</Radio>
              </RadioGroup>
            </FormItem>

            <FormItem
              label="是否限供"
              prop="isLimitVolPerMonth"
            >
              <RadioGroup v-model="formItem.isLimitVolPerMonth">
                <Radio label="true">是</Radio>
                <Radio label="false">否</Radio>
              </RadioGroup>
            </FormItem>

            <FormItem
              label="每月限供吨数"
              prop="limitVolPerMonth"
              v-if="formItem.isLimitVolPerMonth === 'true'"
            >
              <InputNumber
                style="width: 200px"
                :min="0"
                v-model="formItem.limitVolPerMonth"
              ></InputNumber>
            </FormItem>

            <!-- <FormItem
              label="审核"
              prop="salesOrderReview"
            >
              <Select v-model="formItem.salesOrderReview" style="width:200px">
                <Option v-for="item in reviewList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem> -->
          </div>
          <FormItem style="margin-right: 20px">
            <Button
              type="primary"
              @click="handleSubmit('formItem')"
            >更新</Button>
          </FormItem>
        </Form>
      </div>
    </div>
  </Drawer>
</template>

<script>
import { mapState, mapActions } from "vuex";
import _ from "lodash";

export default {
  name: "ReviewDrawer",
  data() {
    return {
      drawerOpened: false,
      currentSales: {},
      formItem: {
        allowSales: "false",
        prePaidOnly: "false",
        isLimitVolPerMonth: "false",
        limitVolPerMonth: 0,
      },
      reviewList: [
        {
          value: 'none',
          label: '直接下单'
        },
        {
          value: 'each',
          label: '每单审核（预付款）'
        },
        {
          value: 'monthly',
          label: '每月审核'
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      updateSales: "sales/updateSalesAction",
      getSalesById: "sales/getSalesByIdAction",
      updateSalesWithCost: "sales/updateSalesWithCostAction",
    }),
    async openDrawer(sales) {
      this.drawerOpened = true;
      this.currentSales = sales
      this.formItem.allowSales = sales.allowSales ? 'true' : 'false';
      this.formItem.prePaidOnly = sales.prePaidOnly ? 'true' : 'false';
      this.formItem.isLimitVolPerMonth = sales.isLimitVolPerMonth ? 'true' : 'false';
      this.formItem.limitVolPerMonth = sales.limitVolPerMonth || 0;
    },
    async handleSubmit() {
      try {
        await this.updateSales({
          id: this.currentSales._id,
          data: this.formItem,
        });
        this.updateSalesWithCost({
          id: this.currentSales._id,
          ...this.formItem
        })
        this.$Message.success("更新成功!");
        this.drawerOpened = false;
      } catch (error) {
        this.$Message.error(`失败: ${error}`);
      }
    }
  },
};
</script>
<style lang="stylus" scoped>
.drawer-wrap
  padding 20px
  font-size 16px

.drawer-contetn
  display flex

</style>